

import React, { memo } from 'react';
import cx from 'classnames';
import { SizeMe } from 'react-sizeme';
import { Button, Text, ElevatedContainer, Icon } from '../../../ui-kit';
import CollapsedBanner from './CollapsedBanner';
import mediaSizes from '../../../common/constants/mediaSizes';
import '../styles/_sign-up-banner.scss';

const defaultHeader = 'Ready to get rolling on your videos?';
const defaultInfo = 'The Shootsta Platform has so much to offer, and so much more to come. If you’d like to jump in and get full access to our app collection, subscribe now!';

















function SignUpBanner({
  headerText = defaultHeader,
  infoText = defaultInfo,
  headerTextClassName = '',
  infoTextClassName = '',
  product,
  collapsed = false,
  isNewDesign = false,
  btnText = 'Get in Touch',
  onClick,
  onShow,
  className,
  onClickCloseBtn,
  btnType = 'PRIMARY'
}) {
  const renderTextContent =
  <>
      <Text className={cx('sign-up-banner__header', headerTextClassName)}>{headerText}</Text>
      <Text className={cx('sign-up-banner__info', infoTextClassName)}>{infoText}</Text>
    </>;


  return (
    <SizeMe>
      {({ size: { width } }) => {
        if (collapsed) {
          return (
            <CollapsedBanner
              product={product}
              width={width}
              onShow={onShow} />);


        }

        return (
          <ElevatedContainer className={cx(
            'sign-up-banner',
            { 'sign-up-banner--medium': width < mediaSizes.medium },
            { 'sign-up-banner--small': width < mediaSizes.small },
            { 'sign-up-banner--position': onClickCloseBtn },
            className
          )}>

            {
            isNewDesign ?
            <div>
                  {renderTextContent}
                </div> :
            renderTextContent}


            {
            onClickCloseBtn &&
            <Icon onClick={onClickCloseBtn} name="close" color="white" size={18} className="sign-up-banner__close" />}



            <Button onClick={onClick} type={btnType} className="sign-up-banner__button">{btnText}</Button>
          </ElevatedContainer>);

      }}
    </SizeMe>);

}

export default memo(SignUpBanner);